import { schema } from "normalizr";

import { Entity } from "@/mk2/schemas";

export interface ArticleLinkEntity extends Entity {
    title: string;
    slug: string;
}

export const ArticleLinkSchema = new schema.Entity("articleLink", {});
